module.exports = __webpack_public_path__ + "img/icon_App-Store.2928664f.svg";